import type { RouteLocationNormalized, Router } from 'vue-router'
import { PATH_AUTH_FAIL, useAuthentificationStore } from '../index.js'
import { isNotNullUndefinedOrEmptyString } from '@/features/shared/tools/object.js'

declare module 'vue-router' {
  interface RouteMeta {
    /** L'accés à la page nécessite d'être authentifié */
    requiresAuth?: boolean
  }
}

export function registerAuthGuard(router: Router) {
  let estRouteAuthActive = true
  router.beforeEach(async (to: RouteLocationNormalized, _from: RouteLocationNormalized) => {
    const { initializeAsync, authentificationRequiseAsync, attendreFlotAuthentificationAsync } = useAuthentificationStore()

    // Fix : le retour d'authentification Azure
    if (estRouteAuthActive && to.fullPath.startsWith('/#code')) {
      await attendreFlotAuthentificationAsync()
      if (estRouteAuthActive)
        return '/'
      else
        return false
    }
    estRouteAuthActive = false

    const estAuthentifié = await initializeAsync(to.fullPath)
    try {
      const requireImperso = isNotNullUndefinedOrEmptyString(to.query['user-imperso'])
      if ((estAuthentifié === false && to.meta.requiresAuth) || requireImperso) {
        const result = (await authentificationRequiseAsync(to.fullPath, false)) || PATH_AUTH_FAIL
        if (result === true && requireImperso) {
          delete to.query['user-imperso']
          return to
        }
        return result
      }

      return true
    } catch (error) {
      console.error("Echec de l'authentification", error)
      return PATH_AUTH_FAIL
    }
  })
}
